// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.font_size_title[data-v-38d628c0] {\n  font-size: 18px;\n  color: #000000;\n}\n.mb-12[data-v-38d628c0]{\n  margin-bottom: 12px;\n}\n.mt-12[data-v-38d628c0]{\n  margin-top: 14px\n}\n", ""]);
// Exports
module.exports = exports;
